/*
 * @Author: your name
 * @Date: 2020-07-07 11:09:58
 * @LastEditTime: 2021-07-29 10:16:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/config.js
 */
/**
 * 配置信息
 */
let host = location.hostname
// 接口的环境变量
let env='';
// url的环境变量，因为接了van，要拼多个-v
// 「测试环境」投放渠道使用的也是-v的链接
let env_web='';
let isXl = /.xiaolachuxing/.test(host);
if(/-dev|localhost|^192\.168|^172/.test(host)){
  env = '-stg'
  env_web = '-v-stg'
  isXl = true; // debug
}else if(/-stg/.test(host)){
  env = '-stg'
  env_web = '-v-stg'
}else if(/-pre/.test(host)){
  env = '-pre'
  env_web = '-v-pre'
}else if(/-gra/.test(host)){
  env = '-gra'
  env_web = '-v-gra'
}else{
  env = ''
  env_web = ''
}
// let ajaxUrl = isXl? `https://invoicep${env}.xiaolachuxing.com/index.php`:`https://invoicep${env}.huolala.cn/index.php`,
let ajaxUrl = `https://invoice-api${env}.xiaolachuxing.com/index.php`,
hostUrl = `https://invoice${env_web}.xiaolachuxing.com/#/`,
eappUrl = `https://eappweb${env}.huolala.cn/#/verify/detail`,
eappRechage=`https://eappweb${env}.huolala.cn/#/recharge`,//企业认证
scheduleUrl = `https://uappweb${env}.huolala.cn/order_trip/index.html`;
export default {
  hostUrl,ajaxUrl,env,env_web,eappUrl,eappRechage,scheduleUrl,isXl
}



// WEBPACK FOOTER //
// ./src/config.js